let phoneActive = false;
var PageType;
var PageTypes = {
    HOME: 'HOME',
    PRODUCT: 'PRODUCT',
    CART: 'CART',
    CHECKOUT: 'CHECKOUT',
    ORDERS: 'ORDERS'
}

var DeviceType;
var DeviceTypes = {
    DESKTOP: 'DESKTOP',
    MOBILE: 'MOBILE'
}

window.addEventListener("pageshow", function (event) {
    if (event.persisted) {
        window.location.reload();
    }
});
window.mobileCheck = function () {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);

    if (check) {
        DeviceType = DeviceTypes.MOBILE;
    }
    else {
        DeviceType = DeviceTypes.DESKTOP;
    }

    return check;
};
window.onscroll = function (ev) {
    var cart_floating = document.getElementsByClassName('section-cart')[0];
    var scroll_floating = document.getElementById('scrollUpButton');

    if (Math.round(window.scrollY) > 150) {
        if (scroll_floating) {
            scroll_floating.style.display = 'flex';
        }

        if (cart_floating) {
            if (cart_floating.style.display != 'flex') {
                cart_floating.style.display = 'flex';
                cart_floating.classList.add('section-cart-slide-in');

                setTimeout(() => {
                    cart_floating.classList.remove('section-cart-slide-in');
                }, 400);
            }
        }
    }
    else {
        if (scroll_floating) {
            scroll_floating.style.display = 'none';
        }
        if (cart_floating) {
            cart_floating.style.display = 'none';
        }
    }

    if (navbarType == "DEFAULT") {
        updateSectionProgressBar();
    }
};

document.addEventListener("DOMContentLoaded", () => {
    phoneActive = mobileCheck();

    setPageType();

    //SECTIONS OVERFLOW LOGIC
    const notification = document.getElementById("notification_top_cont");
    const notification_cont = document.getElementById("notification_top_content_cont");
    function checkOverflow() {
        if (notification) {
            if (notification.scrollHeight > notification.clientHeight ||
                notification.scrollWidth > notification.clientWidth) {
                notification.classList.add("notification-overflow");
                notification_cont.classList.add("notification-content-overflow");
            } else {
                notification.classList.remove("notification-overflow");
                notification_cont.classList.remove("notification-content-overflow");
            }
        }
    }

    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    ///

    //SEARCH KEYPRESS
    $('#searchInput').bind('keyup', function (e) {
        if (e.keyCode === 13) {
            onSearch();
        }
    });


    configureNavbarSearchBar();


    var contactContainerAbs = document.getElementById('contact-info');
    contactContainerAbs.addEventListener('click', function (event) {
        var contactButton = document.getElementsByClassName('nr-row1')[0];
        var contactSideNavButton = document.getElementsByClassName('sd-row2')[0];
        var contactContainer = document.getElementById('contact-info').getElementsByClassName('a-c-i-box')[0];
        const clickedOutside =
            (!contactButton || !contactButton.contains(event.target) &&
                (!contactContainer || !contactContainer.contains(event.target) &&
                    (!contactSideNavButton || !contactSideNavButton.contains(event.target)
                    )));
        if (clickedOutside) {
            hideContactInfo();
        }
    });

    var locationsContainerAbs = document.getElementById('locations-info')
    locationsContainerAbs.addEventListener('click', function (event) {
        var locationsButton = document.getElementsByClassName('nr-row4')[0];
        var locationsSideNavButton = document.getElementsByClassName('sd-row1')[0];
        var locationsContainer = document.getElementById('locations-info').getElementsByClassName('a-c-i-box')[0];
        const clickedOutsideLoc =
            (!locationsButton || !locationsButton.contains(event.target) &&
                (!locationsContainer || !locationsContainer.contains(event.target) &&
                    (!locationsSideNavButton || !locationsSideNavButton.contains(event.target)
                    )));
        if (clickedOutsideLoc) {
            hideLocationsInfo();
        }
    });

});

//SEARCH BAR
function onSearch() {
    var searchInput = document.getElementById('searchInput').value;
    window.location.assign(`${apiPath}/Home?hfty=${TableID}&y=${SectionID}&f=${searchInput}&j=`);
}

//ORDER FILTER SIDENAV
function filterOrder(element) {
    var filter, table, tr, td, i, txtValue;
    filter = input.value.toUpperCase();
    table = document.getElementById("table");
    tr = table.getElementsByTagName("tr");
    for (i = 0; i < tr.length; i++) {
        const tableData = tr[i].getElementsByTagName("td");
        let allTextContent = '';
        for (let ind = 0; ind < tableData.length; ind++) {
            allTextContent += tableData[ind].innerText;
        }

        if (allTextContent) {
            if (allTextContent.toUpperCase().indexOf(filter) > -1) {
                tr[i].style.display = "";
            } else {
                tr[i].style.display = "none";
            }
        }
    }
}

//MISC
function setPage(value) {
    var params = new URLSearchParams(location.search);
    params.set('p', value);
    window.location.search = params.toString();
}
function incrementCartCounter() {
    var cartCount = document.getElementById('cart-ammount');
    var cartCount2 = document.getElementById('cart-ammount-2');
    var cartCount3 = document.getElementById('cart-ammount-3');

    if (cartCount) {
        cartCount.innerText = parseInt(parseInt(cartCount.innerText) + 1);
    }
    if (cartCount2) {
        cartCount2.innerText = parseInt(parseInt(cartCount2.innerText) + 1);
    }
    if (cartCount3) {
        cartCount3.innerText = parseInt(parseInt(cartCount3.innerText) + 1);
    }
}
function decreaseCartCounter() {
    var cartCount = document.getElementById('cart-ammount');
    var cartCount2 = document.getElementById('cart-ammount-2');
    var cartCount3 = document.getElementById('cart-ammount-3');

    if (cartCount) {
        cartCount.innerText = parseInt(parseInt(cartCount.innerText) - 1);
    }
    if (cartCount2) {
        cartCount2.innerText = parseInt(parseInt(cartCount2.innerText) - 1);
    }
    if (cartCount3) {
        cartCount3.innerText = parseInt(parseInt(cartCount3.innerText) - 1);
    }
}

function hideContactInfo() {
    var contactInfo = document.getElementById('contact-info');
    if (contactInfo) {
        contactInfo.style.display = 'none';
    }
}
function showContactInfo() {
    var contactInfo = document.getElementById('contact-info');
    if (contactInfo) {
        contactInfo.style.display = 'flex';
        closeSideNav();
    }
}
function exitSearchMode(){
    const url = new URL(window.location.href);
    url.searchParams.delete("f");
    window.location.replace(url.toString());
}
function showLocationsInfo() {
    var locationsInfo = document.getElementById('locations-info');
    if (locationsInfo) {
        locationsInfo.style.display = 'flex';
        closeSideNav();
    }
}
function hideLocationsInfo() {
    var locationsInfo = document.getElementById('locations-info');
    if (locationsInfo) {
        locationsInfo.style.display = 'none';
    }
}
function setPageType() {
    const segments = window.location.pathname
        .split('/')
        .filter(Boolean)               
        .map(s => s.toUpperCase());    

    PageType = null;
    for (const segment of segments.reverse()) {
        if (Object.values(PageTypes).includes(segment)) {
            PageType = segment;
            break;
        }
    }
}
function getImages(ProductID, SectionID, TableID) {
    $.ajax({
        type: "GET",
        url: scriptPath + `/API/Catalog/GetProductCarroussel?hfty=${TableID}&y=${SectionID}&f=${ProductID}`,
        headers: {
            RequestVerificationToken:
                $('input:hidden[name="__RequestVerificationToken"]').val()
        },
        success: function (result) {
            $('body').append(`
                <div class="imageFocusAbsolute">
                    <div class="ifa-cont">
                        <button type="button" onclick="this.parentElement.parentElement.remove()"><i class="fa fa-times" aria-hidden="true"></i></button>
                        ${result}
                    </div>
                </div>
            `);
        },
        error: function (result) {
            showToast("Ocurrió un error", "danger", 3000);
        }
    });
}
function configureNavbarSearchBar() {
    var searchBar = document.getElementById('searchInput');

    switch (PageType) {
        case PageTypes.HOME:
        case PageTypes.PRODUCT:
            searchBar.placeholder = 'Buscar en el catálogo...';
            break;
        case PageTypes.CART:
            searchBar.placeholder = 'Buscar en el carrito...';
            searchBar.setAttribute('onkeyup', 'searchRequest(this)');
            break;
        case PageTypes.CHECKOUT:
            searchBar.placeholder = 'Buscar en el carrito...';
            break;
        case PageTypes.ORDERS:
            searchBar.placeholder = 'Buscar producto...';
            searchBar.setAttribute('onkeyup', 'searchRequest(this)');
            break;
    }
}